import { render, staticRenderFns } from "./ProductInformationBlocks.vue?vue&type=template&id=64ec4888&scoped=true&"
import script from "./ProductInformationBlocks.vue?vue&type=script&lang=js&"
export * from "./ProductInformationBlocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ec4888",
  null
  
)

export default component.exports